<template>
  <div class="list-item-file smd-panel m-b-20"
       @click="viewFile">
    <div class="file">
      <div class="pxmaterial-image-container">
        <img :src="fileData.coverurl" :alt="fileData.title"/>
      </div>

      <div class="text">
        <h2 class="list-item-file__title"
            :class="!$isDesktop ? 'Title1' : 'Title2'">
            {{ pxMaterialListTitle }}
        </h2>
        <p class="Body3"
          :class="!$isDesktop ? 'm-b-10' : 'm-b-20'">
          By {{fileData.author}}
        </p>
        <text-string :label-id="$isDesktop ? 'txt040__desktop' : 'txt040'"
                     :props="{strings: [materialPatientName, '']}"
                     :class="{'m-b-5': $isDesktop}"/>
        <p class="gray-400" :class="$isDesktop ? 'Label1' : 'Body3'">{{ formattedDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {toPhilMoment} from '@/utils/dates';
  import TitleMixin from '@/mixins/title-mixin';
  import MixinPreviewEducFile from '@/mixins/preview-educ-file-mixin';

  import educContentPage from '@/components/messages/educ-content-page';

  import {
    GETTER_TOKENS,
    GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN,
  } from '@/store/types';

  export default {
    name: 'list-item-file-pxmaterial',
    mixins: [
      TitleMixin,
      MixinPreviewEducFile,
    ],
    props: {
      fileData: {type: Object, required: false},
    },
    computed: {
      ...mapGetters({
        tokens: GETTER_TOKENS,
        getterDoctorPatientByToken: GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN,
      }),
      formattedDate() {
        const dateReceived = toPhilMoment(this.fileData.dateshared);
        const dateFormat = dateReceived.format('MMMM DD, YYYY');
        const timeFormat = dateReceived.format('h:mm a');
        return `Sent on ${dateFormat} at ${timeFormat}`;
      },
      pxMaterialListTitle() {
        return this.computedTitle({
                ...this.fileData,
                doctorname: `Dr. ${this.fileData.doctorfirstname} ${this.fileData.doctorlastname}`,
              });
      },
      materialPatientName() {
        const pxObj = this.tokens.find(({token}) => this.fileData.token === token);
        return pxObj || pxObj.patient ? pxObj.patient.name : '';
      },
    },
    methods: {
      viewFile() {
        if (this.fileData.pxmaterialtype === 'custom') {
          this.$modal.open({
            component: educContentPage,
            size: 'full-screen',
            position: 'detached auto-height',
            props: {
              content: this.fileData,
              token: this.getterDoctorPatientByToken[this.fileData.token].accesstoken,
            }
          });
        } else if (this.fileData.pxmaterialtype === 'files') {
          this.getFilesAttached(this.fileData.files,
                                this.fileData.msgid,
                                this.getterDoctorPatientByToken[this.fileData.token].accesstoken);
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  .file {
    grid-column: 1 / -1;

    @include make-grid(60px 1fr, max-content, 10px);
    @extend %align-items-start;
    overflow: hidden;

    @include responsive() {
      grid-template-columns: 50px 1fr;
      gap: 8px;
    }

    .pxmaterial-image-container {
      height: 60px;

      @include responsive() {
        height: 50px;
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 8px;
        object-fit: cover;
      }
    }
  }
</style>
